module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_serif-regular-web.eot?497fcd325deefa7554a3776b34520205";